












































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { inquiryModule } from '@/contactus/store/modules/inquiry';

@Component
export default class Confirmation extends Vue {
    is_sending = false;
    has_error = false;

    get subject(): string {
        return inquiryModule.subject;
    }

    get message(): string {
        return inquiryModule.message;
    }

    get relatedContent(): string {
        return inquiryModule.relatedContent;
    }

    get name(): string {
        return inquiryModule.name;
    }

    get email(): string {
        return inquiryModule.email;
    }

    get company(): string {
        return inquiryModule.company;
    }

    @Watch('$route')
    changeRoute() {
        this.has_error = false;
    }

    back() {
        this.$emit('change-page-form');
    }

    async send() {
        this.is_sending = true;
        this.has_error = false;
        await inquiryModule.createInquiry({
                locale: this.$i18n.locale,
                subject: this.subject,
                message: this.message,
                relatedContent: this.relatedContent,
                name: this.name,
                email: this.email,
                company: this.company
            });
        this.is_sending = false;
        
        if (inquiryModule.has_api_error) {
            this.has_error = true;
        } else {
            this.$emit('change-page-finish');
        }
    }
}
